import { graphql } from '@/generated/gql';

export const INTAKE_QUOTE_COMPLIANCE_MUTATION = graphql(`
  mutation IntakeQuoteComplianceMutation($data: SvbrgQuoteComplianceNextInput!) {
    sevenbridges {
      chatSession {
        quoteCompliance {
          next(data: $data) {
            id
            chatSessionId
            quoteId
            score
            userComment
            userReason
            complianceData {
              summary
              parts {
                details
                section
                status
                sourceFileName
              }
            }
          }
        }
      }
    }
  }
`);
